import { render, staticRenderFns } from "./StudioElettrofisiologicoEdit.vue?vue&type=template&id=5a70b43c&scoped=true"
import script from "./StudioElettrofisiologicoEdit.vue?vue&type=script&lang=js"
export * from "./StudioElettrofisiologicoEdit.vue?vue&type=script&lang=js"
import style0 from "./StudioElettrofisiologicoEdit.vue?vue&type=style&index=0&id=5a70b43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70b43c",
  null
  
)

export default component.exports